export default "__VITE_ASSET__DoQJmJko__"